import { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { UseFestivalManagment } from "./UseFestivalManagment";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import BrandSearchCom from "../../basic-information/brand/BrandSearchCom";
import SelectGroup from "../../ContentManagement/firstPage/HomeOffer/SelectGroup";
import SearchComOff from "../../ContentManagement/firstPage/HomeOffer/SearchComOff";
import useBreakpoints from "../../hooks/useBreakpoints";
import { rsProgress } from "../../RecoilStates";

export default function AddFestivalDisccount(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { addFestivalDiscount } = UseFestivalManagment();
  const [discountPercent1, setDiscountPercent1] = useState("");
  const [discountPercent2, setDiscountPercent2] = useState("");
  const [discountPercent3, setDiscountPercent3] = useState("");
  const [name, setName] = useState("");
  const [state, setState] = useState({
    productID: undefined,
    brandID: undefined,
    groupID: undefined,
    discountPercent: undefined,
    festivalID: props.festivalID,
  });
  const { isSmall } = useBreakpoints();

  return (
    <Box>
      <Typography color="secondary" sx={{ mb: 2 }} variant="subtitle1">
        افزودن تخفیف
      </Typography>
      <Box
        sx={{
          mb: 4,
          borderRadius: 1,
          p: 2,
          boxShadow: 2,
        }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={2}
      >
        <Box gridColumn={isSmall ? "span 12" : "span 10"}>
          <Box
            sx={{
              display: "flex",
              flexDirection: isSmall ? "column" : "row",
              alignItems: isSmall ? "flex-start" : "center",
              gap: 2,
            }}
          >
            <SearchComOff
              article={isSmall ? true : false}
              productID={state.productID}
              productModel={state}
              setProductModel={setState}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <TextField
                sx={{
                  width: "50%",
                  input: {
                    textAlign: "center",
                  },
                }}
                value={discountPercent1 ? discountPercent1 : ""}
                label="درصد تخفیف"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setDiscountPercent1(evt.target.value);
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <Button
                sx={{ width: "70px" }}
                variant="contained"
                // disabled={!state.productID}
                onClick={() => {
                  var model = {
                    festivalID: props.festivalID,
                    productID: state.productID,
                    discountPercent: discountPercent1,
                  };
                  if (!model.productID || !model.discountPercent) {
                    enqueueSnackbar("اطلاعات تخفیف مشخص نیست", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  setProgress(true);
                  addFestivalDiscount(model, (calback) => {
                    setState({
                      ...state,
                      productID: undefined,
                      brandID: undefined,
                      groupID: undefined,
                      discountPercent: undefined,
                    });
                    setDiscountPercent1("");
                    props.callback();
                  });
                }}
              >
                افزودن
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mb: 4,
          borderRadius: 1,
          p: 2,
          boxShadow: 2,
        }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={2}
      >
        <Box gridColumn={isSmall ? "span 12" : "span 4"}>
          <BrandSearchCom
            name={name}
            setName={setName}
            selectedBrandID={state.brandID}
            setter={setState}
            lvl1State={state}
            Offer
          ></BrandSearchCom>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            gap: 2,
          }}
          gridColumn={isSmall ? "span 12" : "span 7"}
        >
          <TextField
            sx={{
              width: isSmall ? "50%" : "25%",
              mr: 2,
              input: {
                textAlign: "center",
              },
            }}
            value={discountPercent2 ? discountPercent2 : ""}
            label="درصد تخفیف"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setDiscountPercent2(evt.target.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isSmall && "flex-end",
              // width: "100%",
              gap: 2,
            }}
          >
            <Button
              sx={{ width: "70px" }}
              variant="contained"
              onClick={() => {
                var model = {
                  festivalID: props.festivalID,
                  brandID: state.brandID,
                  discountPercent: discountPercent2,
                };
                if (!model.brandID || !model.discountPercent) {
                  enqueueSnackbar("اطلاعات تخفیف مشخص نیست", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
                setProgress(true);
                addFestivalDiscount(model, (calback) => {
                  setState({
                    ...state,
                    productID: undefined,
                    brandID: undefined,
                    groupID: undefined,
                    discountPercent: undefined,
                  });
                  setName("");
                  setDiscountPercent2("");
                  props.callback();
                });
              }}
            >
              افزودن
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mb: 2,
          // bgcolor: "#e3e3e340",
          borderRadius: 1,
          p: 2,
          boxShadow: 2,
        }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={2}
      >
        <Box gridColumn="span 12">
          <SelectGroup
            Offer
            setName={setName}
            selectedGroupID={state.groupID && state.groupID}
            setter={setState}
            lvl1State={state}
          ></SelectGroup>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
          gridColumn="span 12"
        >
          <TextField
            sx={{
              width: isSmall ? "50%" : "18%",
              mr: 2,
              input: {
                textAlign: "center",
              },
            }}
            value={discountPercent3 ? discountPercent3 : ""}
            label="درصد تخفیف"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setDiscountPercent3(evt.target.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isSmall && "flex-end",
              // width: "100%",
              gap: 2,
            }}
          >
            <Button
              sx={{ width: "70px" }}
              variant="contained"
              onClick={() => {
                var model = {
                  festivalID: props.festivalID,
                  groupID: state.groupID,
                  discountPercent: discountPercent3,
                };
                if (!model.groupID || !model.discountPercent) {
                  enqueueSnackbar("اطلاعات تخفیف مشخص نیست", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
                setProgress(true);
                addFestivalDiscount(model, (calback) => {
                  setState({
                    ...state,
                    productID: undefined,
                    brandID: undefined,
                    groupID: undefined,
                    discountPercent: undefined,
                  });
                  setDiscountPercent3("");
                  props.callback();
                });
              }}
            >
              افزودن
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
